import { FieldName } from './types.d';

// Order in which additional part fields render (serial number → internal number → RMA number).
export const FIELD_ORDER: FieldName[] = ['serial_number', 'internal_number', 'rma_number'];

// Fields excluded from the "new part" section — RMA only applies to the defective
// part being returned, not the new replacement part.
export const NEW_PART_EXCLUDED_FIELDS: FieldName[] = ['rma_number'];

export const ALLOWED_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/bmp',
  'image/avif',
  'image/heic',
  'image/heif',
]);
export const MAX_FILE_SIZE = 20 * 1024 * 1024;
export const MAX_FILE_COUNT = 5;
// The shared parts-and-shipments axios instance defaults to a 10s timeout, which is
// too short for a 20MB image on a slow connection. Override per upload request.
export const PART_FILE_UPLOAD_TIMEOUT_MS = 60 * 1000;
export const ACCEPT = [...ALLOWED_TYPES].join(',');
export const FILE_INPUT_HELP_TEXT = 'Files must be less than 20MB. Accepted file types: JPG, PNG, WEBP, BMP, AVIF, HEIC, HEIF.';
export const DELETE_CONFIRMATION_MESSAGE = 'Are you sure you want to delete ';
